import LanguageIcon from '@mui/icons-material/Language';
import Button from "@mui/material/Button";
import { observer } from "mobx-react-lite";
import { Menu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import i18nStore, { AvailableLanguages } from "./store";


const ChangeLanguageBtn = observer(() => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleChoose = (keyLang: string | object) => {
        if (typeof keyLang === "string") {
            const prevLang = i18nStore.getCurrentLanguageCode;
            i18nStore.update(keyLang);
            if (prevLang !== keyLang) {
                // window.location.reload();
            }
        }
        setAnchorEl(null);
    };
    
    let langItems: any[] = [];
    AvailableLanguages.forEach((value: string, key: string, map: Map<string, string>) => {
        langItems.push(
            <MenuItem key={key} onClick={() => handleChoose(key)}>{key.toUpperCase()} {value}</MenuItem>
        );
    });

    return (
        <>
            <Button
                onClick={handleClick}
                sx={{ px: 1, borderRadius: "4px", color: "white" }}
                endIcon={<LanguageIcon />}
            >
                {i18nStore.getCurrentLanguageCode.toUpperCase()}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleChoose}
            >
                {langItems}
            </Menu>
        </>
    );
});

export default ChangeLanguageBtn;
